import React from 'react';
import { get, includes } from 'lodash';
import { useCurrentMaster, useCurrentUser } from '@lib/hooks';

export default function useHasAccessToConfirmDialogAppointment() {
  const currentUser = useCurrentUser();
  const currentMaster = useCurrentMaster();
  const currentUserRollouts = React.useMemo(() => get(currentUser, 'rollouts', get(currentMaster, 'rollouts', [])), [
    currentMaster,
    currentUser,
  ]);
  // @ts-ignore
  const hasAccessConfirmDialogAppointment = includes(currentUserRollouts, 'appointment-confirm-dialog');

  return hasAccessConfirmDialogAppointment;
}
